import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { useOnClickOutside } from "../hooks/useOnClickOutSide";
import { DropdownToggle } from "./components/DropdownToggle";
import style from "./styles.pcss";
import { DropdownList } from "./components/DropdownList";
var cn = classNames.bind(style);

/**
 * @deprecated компонент, используйте Select
 */
var Dropdown = /*#__PURE__*/memo(function (_ref) {
  var options = _ref.options,
    onChange = _ref.onChange,
    title = _ref.title,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? {
      isError: false,
      message: ''
    } : _ref$error,
    helpMessage = _ref.helpMessage,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'main' : _ref$theme,
    value = _ref.value,
    _ref$isNoSelectedOpti = _ref.isNoSelectedOption,
    isNoSelectedOption = _ref$isNoSelectedOpti === void 0 ? false : _ref$isNoSelectedOpti,
    _ref$emptyValueText = _ref.emptyValueText,
    emptyValueText = _ref$emptyValueText === void 0 ? 'Выберите' : _ref$emptyValueText,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Select' : _ref$testName,
    icon = _ref.icon,
    dropdownListClassName = _ref.dropdownListClassName;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setOpen = _useState2[1];
  var _useState3 = useState(function () {
      return options.find(function (_ref2) {
        var slug = _ref2.slug;
        return slug === value;
      }) || {};
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    activeOption = _useState4[0],
    setActiveOption = _useState4[1];
  var ref = useRef(null);
  useOnClickOutside({
    ref: ref,
    handler: function handler() {
      return setOpen(false);
    }
  });
  var toggle = useCallback(function () {
    return setOpen(!isOpen);
  }, [isOpen]);
  var onOptionClicked = useCallback(function (option) {
    onChange === null || onChange === void 0 ? void 0 : onChange(option.slug || '');
    toggle();
  }, [toggle, onChange]);
  useEffect(function () {
    if (value) {
      var chosenOption = options.find(function (_ref3) {
        var slug = _ref3.slug;
        return slug === value;
      });
      if (!chosenOption || chosenOption.slug === (activeOption === null || activeOption === void 0 ? void 0 : activeOption.slug)) {
        return;
      }
      setActiveOption(chosenOption);
    }
  }, [value, activeOption, options, setActiveOption]);
  useEffect(function () {
    if (!value && Object.keys(activeOption).length !== 0) {
      setActiveOption({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn('dropdown', {
      'dropdown--short': !!icon
    }),
    "data-component": testName,
    ref: ref
  }, title && !isNoSelectedOption && /*#__PURE__*/React.createElement("p", {
    className: cn('title')
  }, title), /*#__PURE__*/React.createElement(DropdownToggle, {
    disabled: disabled,
    emptyValueText: emptyValueText,
    error: error,
    helpMessage: helpMessage,
    icon: icon,
    isOpen: isOpen,
    onClick: toggle,
    option: activeOption,
    theme: theme,
    title: isNoSelectedOption ? title : undefined
  }), isOpen && /*#__PURE__*/React.createElement(DropdownList, {
    activeOption: activeOption,
    className: dropdownListClassName,
    onOptionClicked: onOptionClicked,
    options: options
  }));
});
Dropdown.displayName = Dropdown.name;
export { Dropdown };